export const M6_UNIT_9 = {
  id: "m6-u9-daily-life",
  title: "Unidad 9: Daily Life & Routines",
  topic: "Master daily conversations! Use YET, JUST, and ALREADY to talk about your day. Essential for roommates, family, and everyday life!",
  iconType: "calendar-check",
  grammarImage: "/grammar/grammar-m6-u9.jpg",
  grammarText: "YET (todavía no), JUST (acabo de), ALREADY (ya). Present Perfect for recent actions + Past Simple for details. Learn to navigate daily life conversations!",
  sets: [

    // ===================================================================
    // SET 1: ALREADY - I'VE ALREADY DONE IT (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s1",
      title: "Set 1: ALREADY (Ya lo hice)",
      questions: [
        {
          type: "mc",
          q: "Mom: 'Can you walk the dog?' You: 'I've ___ walked him.'",
          options: ["already", "yet", "just"],
          a: "already",
          tip: "ALREADY = ya lo hice (task completed)",
          successtip: "✓ALREADY!\nAlready = ya ✓\nMuestra que te ADELANTASTE 👍\nTus padres/roommates dicen esto constantly"
        },
        {
          type: "order",
          q: "Context: Tu roommate pregunta por los platos. Traduce: Ya los lavé.",
          words: ["I've", "already", "washed", "them."],
          a: "I've already washed them.",
          tip: "ALREADY goes after HAVE/HAS",
          successtip: "✓POSICIÓN!\nAlready va DESPUÉS de have/has ✓\nI've already done it 💯\nNativos lo dicen así siempre"
        },
        {
          type: "input",
          q: "'Have you finished your homework?' 'Yes, I've ___ finished it.'",
          a: "already",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓HOMEWORK!\nHomework = tarea 📚\nEsta pregunta = top 3 parent questions 😅"
        },
        {
          type: "mc",
          q: "ALREADY shows you:",
          options: ["Did it BEFORE being asked (proactive)", "Just finished now", "Haven't done it yet"],
          a: "Did it BEFORE being asked (proactive)",
          successtip: "✓PROACTIVE!\nAlready = te adelantaste 🏃\nMuestra responsabilidad\nMakes people happy 😊"
        },
        {
          type: "order",
          q: "Context: Ya le hablaste a tu mamá. Traduce: Ya le hablé a mi mamá.",
          words: ["I've", "already", "called", "my", "mom."],
          a: "I've already called my mom.",
          successtip: "✓CALL MOM!\n'Call mom' = hablarle a mamá 📞\nClassic parent reminder\n'Did you call your mom?' = weekly question"
        },
        {
          type: "mc",
          q: "'Don't forget to pay the rent!' 'Don't worry, ___'",
          options: ["I've already paid it.", "I already paid it.", "I've yet paid it."],
          a: "I've already paid it.",
          tip: "Reassuring = PRESENT PERFECT + already",
          successtip: "✓RENT!\nRent = renta 🏠\nBills + already = adulting conversations 💳"
        },
        {
          type: "input",
          q: "'Did you water the plants?' 'Yes, I've ___ done it.'",
          a: "already",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓WATER PLANTS!\nWater = regar 🌱\nCommon household responsibility check"
        },
        {
          type: "order",
          q: "Context: Mostrando que completaste algo antes. Traduce: Ya compré las groceries.",
          words: ["I've", "already", "bought", "the", "groceries."],
          a: "I've already bought the groceries.",
          tip: "BUY → BOUGHT (irregular)",
          successtip: "✓GROCERIES!\nGroceries = compras/víveres 🛒\n'Get groceries' = common errand"
        },
        {
          type: "mc",
          q: "Where does ALREADY go? 'I have eaten already' vs 'I've already eaten'",
          options: ["Both OK! (British prefer end, Americans prefer middle)", "Only middle correct", "Only end correct"],
          a: "Both OK! (British prefer end, Americans prefer middle)",
          successtip: "✓POSITION FLEXIBLE!\n🇺🇸 Americans: I've already done it\n🇬🇧 British: I've done it already\nAmbas correctas 💯"
        },
        {
          type: "match",
          q: "Match daily tasks with ALREADY",
          pairs: [
            { left: "Morning routine", right: "I've already brushed my teeth" },
            { left: "Chores", right: "I've already taken out the trash" },
            { left: "Communication", right: "I've already texted him" }
          ],
          a: "completed",
          successtip: "✓BRUSH TEETH!\nBrush teeth = lavarse los dientes 🪥\nMorning routine essential"
        }
      ]
    },

    // ===================================================================
    // SET 2: YET - HAVEN'T DONE IT YET (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s2",
      title: "Set 2: YET (Todavía no)",
      questions: [
        {
          type: "mc",
          q: "'Have you fed the cat?' 'No, I haven't fed her ___.'",
          options: ["yet", "already", "just"],
          a: "yet",
          tip: "YET = todavía no (with negatives)",
          successtip: "✓YET!\nYet = todavía no ⏰\nVa al FINAL de la frase\nI haven't done it yet 💯"
        },
        {
          type: "order",
          q: "Context: Todavía no terminas tu tarea. Traduce: Todavía no he terminado mi tarea.",
          words: ["I", "haven't", "finished", "my", "homework", "yet."],
          a: "I haven't finished my homework yet.",
          tip: "YET goes at the END",
          successtip: "✓END POSITION!\nYet SIEMPRE al final ✓\nNo en medio como 'already'\nAsí es, punto 💯"
        },
        {
          type: "input",
          q: "'Did you charge your phone?' 'No, not ___.'",
          a: "yet",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓CHARGE PHONE!\nCharge = cargar 🔌\nSuper common daily question\n'My phone's dead!' = oh no moment 😅"
        },
        {
          type: "mc",
          q: "YET in questions: 'Have you done your laundry ___?'",
          options: ["yet", "already", "just"],
          a: "yet",
          tip: "YET also used in questions (at end)",
          successtip: "✓QUESTIONS!\nYet en preguntas = ¿ya? 🤔\nHave you...yet? = checking status\nRoommate question clásica"
        },
        {
          type: "order",
          q: "Context: Preguntando si alguien respondió email. Traduce: ¿Ya respondiste ese email?",
          words: ["Have", "you", "replied", "to", "that", "email", "yet?"],
          a: "Have you replied to that email yet?",
          successtip: "✓REPLY!\nReply = responder 📧\nReply to (email/message)\nAnswer = más general"
        },
        {
          type: "mc",
          q: "'I haven't walked the dog yet' means:",
          options: ["It's still pending (I need to do it)", "I'll never do it", "I did it already"],
          a: "It's still pending (I need to do it)",
          successtip: "✓PENDING!\nYet = todavía pendiente 📋\nImplica: lo haré pronto\nUseful para excuses 😅"
        },
        {
          type: "input",
          q: "'Has he picked up the kids from school ___?' (checking if done)",
          a: "yet",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓PICK UP!\nPick up = recoger 🚗\nPick up kids/packages/food\nVery common phrasal verb"
        },
        {
          type: "order",
          q: "Context: No has pagado la luz. Traduce: Todavía no he pagado la factura de la luz.",
          words: ["I", "haven't", "paid", "the", "electricity", "bill", "yet."],
          a: "I haven't paid the electricity bill yet.",
          successtip: "✓BILLS!\nElectricity/water/gas/internet bill 💡💧📡\nAdult responsibilities™\nYet = compras tiempo 😅"
        },
        {
          type: "mc",
          q: "ERROR: Which is WRONG?",
          options: ["I yet haven't finished.", "I haven't finished yet.", "Have you finished yet?"],
          a: "I yet haven't finished.",
          tip: "🚨 YET never goes before HAVEN'T!",
          successtip: "🚨 NEVER!\nYet DESPUÉS de haven't ✓\nI haven't...yet = correcto\nI yet haven't = ERROR"
        },
        {
          type: "match",
          q: "Match situations with YET",
          pairs: [
            { left: "Negative", right: "I haven't done it yet" },
            { left: "Question", right: "Have you done it yet?" },
            { left: "Short answer", right: "Not yet" }
          ],
          a: "completed",
          successtip: "✓NOT YET!\n'Not yet' = todavía no ⏰\nShort answer súper común\nNativos lo usan todo el tiempo"
        }
      ]
    },

    // ===================================================================
    // SET 3: JUST - ACABO DE HACERLO (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s3",
      title: "Set 3: JUST (Acabo de)",
      questions: [
        {
          type: "mc",
          q: "'Is dinner ready?' 'Yes, I've ___ finished cooking!'",
          options: ["just", "already", "yet"],
          a: "just",
          tip: "JUST = very recently (acabo de)",
          successtip: "✓JUST!\nJust = acabo de 🕐\nLiterally JUST happened\nSuper recent action 💯"
        },
        {
          type: "order",
          q: "Context: Acabas de llegar a casa. Traduce: Acabo de llegar a casa.",
          words: ["I've", "just", "got", "home."],
          a: "I've just got home.",
          tip: "GET → GOT (irregular). JUST after HAVE",
          successtip: "✓GET HOME!\n🇺🇸 'I just got home' (Past Simple común)\n🇬🇧 'I've just got home' (Perfect común)\nAmbas OK 💯"
        },
        {
          type: "input",
          q: "'Where's Dad?' 'He's ___ left for work.'",
          a: "just",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓LEAVE FOR WORK!\nLeave for = salir hacia 🚗\nJust left = salió hace segundos\nTiming conversations"
        },
        {
          type: "mc",
          q: "JUST shows the action happened:",
          options: ["Moments ago (very recent)", "Earlier today", "Last week"],
          a: "Moments ago (very recent)",
          successtip: "✓TIMING!\nJust = hace nada 🕐\nMuy muy reciente\nMinutos, no horas"
        },
        {
          type: "order",
          q: "Context: Acabas de enviar el mensaje. Traduce: Acabo de enviarle el mensaje.",
          words: ["I've", "just", "sent", "him", "the", "message."],
          a: "I've just sent him the message.",
          tip: "SEND → SENT (irregular)",
          successtip: "✓SEND MESSAGE!\nSend = enviar 📱\nText/email/message\nModern communication verb"
        },
        {
          type: "mc",
          q: "'Can you help me?' 'Sorry, I've just started ___.'",
          options: ["working", "work", "to work"],
          a: "working",
          tip: "JUST + started + -ING",
          successtip: "✓START -ING!\nStart + verb-ing 🎬\nJust started = justo empecé\nExcuse perfecto 😅"
        },
        {
          type: "input",
          q: "Phone rings: 'I can't talk now, I've ___ walked into a meeting.'",
          a: "just",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓WALK INTO!\nWalk into = entrar 🚪\nJust walked into = justo entré\nWork/meeting phrase común"
        },
        {
          type: "order",
          q: "Context: Acabas de despertar. Traduce: Acabo de despertar.",
          words: ["I've", "just", "woken", "up."],
          a: "I've just woken up.",
          tip: "WAKE → WOKEN (irregular)",
          successtip: "✓WAKE UP!\nWake up = despertar ⏰\nJust woken up = still sleepy 😴\nMorning excuse clásico"
        },
        {
          type: "mc",
          q: "Position: 'I've eaten just' vs 'I've just eaten'",
          options: ["Second is correct (after have)", "First is correct", "Both OK"],
          a: "Second is correct (after have)",
          tip: "JUST goes after HAVE/HAS (like already)",
          successtip: "✓POSITION!\nJust DESPUÉS de have ✓\nI've just done it 💯\nNunca al final"
        },
        {
          type: "match",
          q: "Match JUST situations",
          pairs: [
            { left: "Arriving", right: "I've just got here" },
            { left: "Finishing", right: "I've just finished" },
            { left: "Starting", right: "I've just started" }
          ],
          a: "completed",
          successtip: "✓GET HERE!\nGet here/there = llegar 📍\nVery common arrival phrase"
        }
      ]
    },

    // ===================================================================
    // SET 4: DAILY ROUTINE QUESTIONS (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s4",
      title: "Set 4: Daily Check-ins",
      questions: [
        {
          type: "mc",
          q: "Morning question: 'Have you ___ breakfast yet?'",
          options: ["had", "have", "having"],
          a: "had",
          tip: "HAVE breakfast = eat breakfast",
          successtip: "✓HAVE BREAKFAST!\nHave breakfast/lunch/dinner ☕\nNo 'eat' en esta expresión\nBritish: 'Had breakfast?' común"
        },
        {
          type: "order",
          q: "Context: Pregunta de roommate por la mañana. Traduce: ¿Ya te duchaste?",
          words: ["Have", "you", "taken", "a", "shower", "yet?"],
          a: "Have you taken a shower yet?",
          tip: "TAKE a shower (not make)",
          successtip: "✓TAKE A SHOWER!\n🇺🇸 Take a shower\n🇬🇧 Have a shower\nAmbas = ducharse 🚿"
        },
        {
          type: "input",
          q: "'Have you ___ dressed yet?' (put on clothes)",
          a: "got",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["gotten"] },
          successtip: "✓GET DRESSED!\nGet dressed = vestirse 👕\nMorning routine question\nParents ask kids esto 😅"
        },
        {
          type: "mc",
          q: "Checking hygiene: 'Did you ___ your teeth?'",
          options: ["brush", "brushed", "brushing"],
          a: "brush",
          tip: "DID + base verb (Past Simple question)",
          successtip: "✓DID YOU BRUSH!\nDentist/parent question 🪥\nOften Past Simple en US\nPerfect OK también"
        },
        {
          type: "order",
          q: "Context: Preguntando por mascota. Traduce: ¿Ya sacaste al perro?",
          words: ["Have", "you", "walked", "the", "dog", "yet?"],
          a: "Have you walked the dog yet?",
          successtip: "✓WALK THE DOG!\nWalk the dog = pasear al perro 🐕\nTwice a day minimum\nResponsibility check común"
        },
        {
          type: "mc",
          q: "Evening routine: 'Have you ___ your homework?'",
          options: ["done", "made", "finished"],
          a: "done",
          tip: "DO homework (not make or finish alone)",
          successtip: "✓DO HOMEWORK!\nDO homework 📚\nNot 'make' ❌\nParent question #1"
        },
        {
          type: "input",
          q: "'Have you ___ to your mom yet?' (telephone)",
          a: "called",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["talked", "spoken"] },
          successtip: "✓CALL MOM!\nCall/talk to mom 📞\nWeekly reminder típico\nFamily communication check"
        },
        {
          type: "order",
          q: "Context: Antes de salir de casa. Traduce: ¿Ya apagaste las luces?",
          words: ["Have", "you", "turned", "off", "the", "lights?"],
          a: "Have you turned off the lights?",
          successtip: "✓TURN OFF!\nTurn off = apagar 💡\nTurn on = encender\nLeaving house checklist"
        },
        {
          type: "mc",
          q: "Security check: 'Did you ___ the door?'",
          options: ["lock", "locked", "locking"],
          a: "lock",
          tip: "DID + base verb",
          successtip: "✓LOCK THE DOOR!\nLock = cerrar con llave 🔐\nSecurity pregunta importante\nAlways check before bed!"
        },
        {
          type: "match",
          q: "Match daily routines",
          pairs: [
            { left: "Morning", right: "brush teeth, get dressed" },
            { left: "Daytime", right: "walk dog, do homework" },
            { left: "Evening", right: "lock door, turn off lights" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 5: HOUSEHOLD RESPONSIBILITY CHECKS (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s5",
      title: "Set 5: Chore Checks",
      questions: [
        {
          type: "mc",
          q: "Dishes question: 'Have you ___ the dishwasher?'",
          options: ["loaded", "charged", "filled"],
          a: "loaded",
          tip: "LOAD the dishwasher",
          successtip: "✓LOAD DISHWASHER!\nLoad = meter platos 🍽️\nUnload = sacar platos\nDaily kitchen tasks"
        },
        {
          type: "order",
          q: "Context: Checando basura. Traduce: ¿Ya sacaste la basura?",
          words: ["Have", "you", "taken", "out", "the", "trash", "yet?"],
          a: "Have you taken out the trash yet?",
          successtip: "✓TAKE OUT TRASH!\n🇺🇸 'Trash' (US)\n🇬🇧 'Rubbish' (UK)\nWeekly chore típico 🗑️"
        },
        {
          type: "input",
          q: "'Have you ___ away your clothes?' (organize/store)",
          a: "put",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓PUT AWAY!\nPut away = guardar 📦\nVs put on = ponerse 👕\nParent nag clásico 😅"
        },
        {
          type: "mc",
          q: "Laundry: 'I need to ___ the laundry.'",
          options: ["do", "make", "wash"],
          a: "do",
          tip: "DO the laundry (fixed expression)",
          successtip: "✓DO LAUNDRY!\nDO the laundry 👕\nNo 'make' or 'wash' solo\nAsí es, punto 💯"
        },
        {
          type: "order",
          q: "Context: Preguntando por cama. Traduce: ¿Ya tendiste tu cama?",
          words: ["Have", "you", "made", "your", "bed", "yet?"],
          a: "Have you made your bed yet?",
          successtip: "✓MAKE BED!\nMake the bed = tender la cama 🛏️\nMorning routine básico\nMilitary-level parents insist 😅"
        },
        {
          type: "mc",
          q: "Kitchen counter: 'Can you ___ the counter?'",
          options: ["wipe", "clean", "wash"],
          a: "wipe",
          tip: "WIPE = quick clean with cloth",
          successtip: "✓WIPE!\nWipe = limpiar con trapo 🧽\nWipe counter/table/surface\nQuick clean vs deep clean"
        },
        {
          type: "input",
          q: "'Have you ___ the floor yet?' (vacuum)",
          a: "vacuumed",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓VACUUM!\nVacuum = aspirar 🧹\nNoun and verb!\n'The vacuum' / 'to vacuum'"
        },
        {
          type: "order",
          q: "Context: Plantas necesitan agua. Traduce: ¿Ya regaste las plantas?",
          words: ["Have", "you", "watered", "the", "plants", "yet?"],
          a: "Have you watered the plants yet?",
          successtip: "✓WATER PLANTS!\nWater = regar 🌱\nWeekly responsibility\nPlants die = guilt 😢"
        },
        {
          type: "mc",
          q: "Clothes: 'Can you ___ up your jacket?'",
          options: ["hang", "put", "place"],
          a: "hang",
          tip: "HANG up = colgar (on hanger/hook)",
          successtip: "✓HANG UP!\nHang up = colgar 🧥\nCoat/jacket/shirt\nVs 'hang out' = salir 👥"
        },
        {
          type: "match",
          q: "Match chores to verbs",
          pairs: [
            { left: "Dishes", right: "load/unload dishwasher" },
            { left: "Trash", right: "take out" },
            { left: "Clothes", right: "put away / hang up" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 6: WHERE DID YOU...? - LOST ITEMS (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s6",
      title: "Set 6: Where Did You...?",
      questions: [
        {
          type: "mc",
          q: "'Where ___ you put the remote?' (asking location)",
          options: ["did", "have", "are"],
          a: "did",
          tip: "Specific action = PAST SIMPLE (not perfect)",
          successtip: "✓WHERE DID YOU!\nWhere questions = Past Simple 📍\nNo 'have' aquí\nAsking specific location/action"
        },
        {
          type: "order",
          q: "Context: Buscando llaves. Traduce: ¿Dónde dejaste las llaves?",
          words: ["Where", "did", "you", "leave", "the", "keys?"],
          a: "Where did you leave the keys?",
          successtip: "✓KEYS!\nKeys = llaves 🔑\nLost item #1 mundial 😅\n'Where are my keys?!' = daily panic"
        },
        {
          type: "input",
          q: "'Where did you ___ my phone?' (place somewhere)",
          a: "put",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["leave", "place"] },
          successtip: "✓PHONE!\n'Where's my phone?!' 📱\nModern problem\nAlways on silent 😅"
        },
        {
          type: "mc",
          q: "Lost wallet: 'When did you ___ see it?'",
          options: ["last", "latest", "late"],
          a: "last",
          tip: "LAST see = última vez que viste",
          successtip: "✓LAST SEE!\n'When did you last see it?' ⏰\nTrying to retrace steps\nWallet = billetera 💳"
        },
        {
          type: "order",
          q: "Context: Control remoto perdido. Traduce: ¿Dónde está el control remoto?",
          words: ["Where's", "the", "remote", "control?"],
          a: "Where's the remote control?",
          tip: "WHERE'S = where is (present location)",
          successtip: "✓REMOTE!\nRemote control = control remoto 📺\nLost item #2\nAlways between couch cushions 😂"
        },
        {
          type: "mc",
          q: "Glasses: 'I can't find my ___.'",
          options: ["glasses", "glass", "eyeglasses"],
          a: "glasses",
          tip: "GLASSES = always plural!",
          successtip: "✓GLASSES!\nGlasses = lentes 👓\nAlways plural like 'pants'\nOn your head? 😅"
        },
        {
          type: "input",
          q: "'Where did I ___ my wallet?' (place down)",
          a: "put",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["leave", "set"] },
          successtip: "✓PUT!\nPut = poner/dejar 📍\nPut down/put away\nForgetful person question"
        },
        {
          type: "order",
          q: "Context: Cargador de teléfono. Traduce: ¿Has visto mi cargador?",
          words: ["Have", "you", "seen", "my", "charger?"],
          a: "Have you seen my charger?",
          tip: "HAVE YOU SEEN = ¿has visto? (present perfect OK)",
          successtip: "✓CHARGER!\nCharger = cargador 🔌\nModern essential\nAlways disappearing"
        },
        {
          type: "mc",
          q: "Headphones: 'I ___ them on the table.'",
          options: ["left", "leaved", "leave"],
          a: "left",
          tip: "LEAVE → LEFT (irregular)",
          successtip: "✓HEADPHONES!\nHeadphones = audífonos 🎧\nAlways plural\nWireless ones = easier to lose 😅"
        },
        {
          type: "match",
          q: "Match lost items to questions",
          pairs: [
            { left: "Keys", right: "Where did you leave them?" },
            { left: "Phone", right: "Have you seen my phone?" },
            { left: "Remote", right: "Where's the remote?" }
          ],
          a: "completed",
          successtip: "✓TOP 3!\nKeys, phone, remote = holy trinity of lost items 😂\nDaily frustration"
        }
      ]
    },

    // ===================================================================
    // SET 7: PHONE & COMMUNICATION (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s7",
      title: "Set 7: Communication Daily",
      questions: [
        {
          type: "mc",
          q: "'Have you ___ to his message yet?'",
          options: ["replied", "answered", "responded"],
          a: "replied",
          tip: "REPLY TO a message",
          successtip: "✓REPLY TO!\nReply to = responder 📱\nReply to messages/emails\nAnswer = más general"
        },
        {
          type: "order",
          q: "Context: Mensaje pendiente. Traduce: Todavía no le he escrito.",
          words: ["I", "haven't", "texted", "him", "yet."],
          a: "I haven't texted him yet.",
          successtip: "✓TEXT!\nText = enviar mensaje 💬\nVerb and noun!\n'Send a text' / 'text someone'"
        },
        {
          type: "input",
          q: "'Did you ___ my email?' (read and respond)",
          a: "get",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["receive", "see"] },
          successtip: "✓GET EMAIL!\n'Get' = receive 📧\nDid you get my email?\nSuper common work question"
        },
        {
          type: "mc",
          q: "Video call: 'Let's ___ chat tonight.'",
          options: ["video", "call", "phone"],
          a: "video",
          tip: "VIDEO chat (Zoom/FaceTime/etc)",
          successtip: "✓VIDEO CHAT!\nVideo chat = videollamada 📹\nModern communication\nZoom, FaceTime, WhatsApp..."
        },
        {
          type: "order",
          q: "Context: Checar teléfono. Traduce: ¿Ya revisaste tu teléfono?",
          words: ["Have", "you", "checked", "your", "phone", "yet?"],
          a: "Have you checked your phone yet?",
          successtip: "✓CHECK PHONE!\nCheck = revisar 📱\nCheck phone/email/messages\nConstant modern habit"
        },
        {
          type: "mc",
          q: "Social media: 'I need to ___ to his comment.'",
          options: ["reply", "answer", "response"],
          a: "reply",
          tip: "REPLY to comments/posts",
          successtip: "✓SOCIAL MEDIA!\nReply to comments 💬\nLike, comment, share\nModern communication"
        },
        {
          type: "input",
          q: "'Have you ___ the email yet?' (press send)",
          a: "sent",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓SEND!\nSend = enviar 📤\nSend → sent → sent\nEmail/message/file"
        },
        {
          type: "order",
          q: "Context: Llamada perdida. Traduce: ¿Ya le devolviste la llamada?",
          words: ["Have", "you", "called", "him", "back", "yet?"],
          a: "Have you called him back yet?",
          successtip: "✓CALL BACK!\nCall back = devolver llamada 📞\nMissed call etiquette\nImportant follow-up"
        },
        {
          type: "mc",
          q: "Notification: 'Did you ___ the notification?'",
          options: ["see", "saw", "seen"],
          a: "see",
          tip: "DID + base verb",
          successtip: "✓NOTIFICATION!\nNotification = notificación 🔔\nRed dot anxiety 😅\nModern life reality"
        },
        {
          type: "match",
          q: "Match communication actions",
          pairs: [
            { left: "Message", right: "text / reply" },
            { left: "Email", right: "send / check" },
            { left: "Call", right: "call back / answer" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 8: MORNING ROUTINE MASTERY (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s8",
      title: "Set 8: Morning Conversations",
      questions: [
        {
          type: "mc",
          q: "First thing: 'Have you ___ up yet?'",
          options: ["woken", "woke", "wake"],
          a: "woken",
          tip: "WAKE → WOKEN (irregular)",
          successtip: "✓WAKE UP!\nWake up = despertar ⏰\nFirst morning question\nSnooze button enemy 😅"
        },
        {
          type: "order",
          q: "Context: Checando rutina matutina. Traduce: ¿Ya te levantaste?",
          words: ["Have", "you", "got", "up", "yet?"],
          a: "Have you got up yet?",
          tip: "GET UP = leave bed",
          successtip: "✓GET UP!\nWake up ≠ Get up 🛏️\nWake = abrir ojos 👁️\nGet up = salir de cama 🚶\nDifferent steps!"
        },
        {
          type: "input",
          q: "'I've just ___ a shower.' (finished recently)",
          a: "taken",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["had"] },
          successtip: "✓SHOWER!\n🇺🇸 Take a shower\n🇬🇧 Have a shower\nAmbas = ducharse 🚿"
        },
        {
          type: "mc",
          q: "Getting ready: 'I'm ___ dressed right now.'",
          options: ["getting", "taking", "making"],
          a: "getting",
          tip: "GET dressed (process)",
          successtip: "✓GETTING DRESSED!\nGet dressed = vestirse 👕\nProcess happening NOW\n'I'm getting dressed' = don't come in! 🚪"
        },
        {
          type: "order",
          q: "Context: Desayuno listo. Traduce: ¿Ya desayunaste?",
          words: ["Have", "you", "had", "breakfast", "yet?"],
          a: "Have you had breakfast yet?",
          successtip: "✓BREAKFAST!\nHave breakfast ☕\nMost important meal (dicen) 😅\nSkip it = hangry later"
        },
        {
          type: "mc",
          q: "Hygiene check: 'Don't forget to ___ your teeth!'",
          options: ["brush", "wash", "clean"],
          a: "brush",
          tip: "BRUSH teeth (not wash/clean)",
          successtip: "✓BRUSH!\nBrush teeth 🪥\nBrush hair 💇\nBrush = cepillar\nDentist-approved reminder"
        },
        {
          type: "input",
          q: "'Have you ___ your bag?' (prepare for school/work)",
          a: "packed",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓PACK!\nPack = empacar/preparar 🎒\nPack bag/lunch/suitcase\nBefore leaving checklist"
        },
        {
          type: "order",
          q: "Context: Café matutino. Traduce: ¿Ya te hiciste café?",
          words: ["Have", "you", "made", "coffee", "yet?"],
          a: "Have you made coffee yet?",
          successtip: "✓COFFEE!\nMake coffee ☕\nMorning essential\n'Don't talk to me before coffee' = mood 😤"
        },
        {
          type: "mc",
          q: "Leaving house: 'Did you ___ the lights?'",
          options: ["turn off", "close", "stop"],
          a: "turn off",
          tip: "TURN OFF lights",
          successtip: "✓TURN OFF!\nTurn off = apagar 💡\nTurn on = encender\nElectricity bill concern 💸"
        },
        {
          type: "match",
          q: "Match morning routine order",
          pairs: [
            { left: "First", right: "wake up / get up" },
            { left: "Then", right: "shower / get dressed" },
            { left: "Before leaving", right: "pack bag / turn off lights" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 9: EVENING ROUTINE (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s9",
      title: "Set 9: Evening Check-ins",
      questions: [
        {
          type: "mc",
          q: "'Have you ___ dinner yet?' (evening meal)",
          options: ["had", "made", "done"],
          a: "had",
          tip: "HAVE dinner = eat dinner",
          successtip: "✓DINNER!\nHave dinner 🍽️\nEvening meal question\n'What's for dinner?' = daily question"
        },
        {
          type: "order",
          q: "Context: Antes de dormir. Traduce: ¿Ya te lavaste los dientes?",
          words: ["Have", "you", "brushed", "your", "teeth", "yet?"],
          a: "Have you brushed your teeth yet?",
          successtip: "✓BEDTIME!\nBrush teeth before bed 🪥\nParent reminder clásico\nCavity prevention 🦷"
        },
        {
          type: "input",
          q: "'I've just ___ the alarm for tomorrow.' (configure)",
          a: "set",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓SET ALARM!\nSet alarm = poner alarma ⏰\nSet → set → set (same form)\nNight ritual importante"
        },
        {
          type: "mc",
          q: "Security: 'Did you ___ all the doors?'",
          options: ["lock", "close", "shut"],
          a: "lock",
          tip: "LOCK doors (with key)",
          successtip: "✓LOCK!\nLock = cerrar con llave 🔐\nClose = cerrar sin llave 🚪\nDifferent!\nNight security check"
        },
        {
          type: "order",
          q: "Context: Preparando para mañana. Traduce: ¿Ya preparaste tu ropa?",
          words: ["Have", "you", "laid", "out", "your", "clothes", "yet?"],
          a: "Have you laid out your clothes yet?",
          tip: "LAY OUT = prepare/organize for tomorrow",
          successtip: "✓LAY OUT!\nLay out = preparar/poner 👔\nLay → laid → laid\nSaves morning time ⏰"
        },
        {
          type: "mc",
          q: "Pet care: 'Don't forget to ___ the cat!'",
          options: ["feed", "give food", "food"],
          a: "feed",
          tip: "FEED = give food to",
          successtip: "✓FEED!\nFeed = alimentar 🐱\nFeed the cat/dog/fish\nThey remind you 😾"
        },
        {
          type: "input",
          q: "'Have you ___ your homework?' (complete)",
          a: "done",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["finished"] },
          successtip: "✓HOMEWORK!\nDo homework 📚\nEvening task\nParent check before TV 📺"
        },
        {
          type: "order",
          q: "Context: Electrodomésticos. Traduce: ¿Apagaste la estufa?",
          words: ["Did", "you", "turn", "off", "the", "stove?"],
          a: "Did you turn off the stove?",
          successtip: "✓STOVE!\nStove = estufa 🔥\nImportant safety check\nFire prevention 🚒"
        },
        {
          type: "mc",
          q: "Tomorrow prep: 'Have you ___ your lunch?'",
          options: ["packed", "made", "prepared"],
          a: "packed",
          tip: "PACK lunch = prepare lunch for tomorrow",
          successtip: "✓PACK LUNCH!\nPack lunch = preparar lonchera 🥪\nSave money vs buying 💰\nHealthy choice 🥗"
        },
        {
          type: "match",
          q: "Match evening routine",
          pairs: [
            { left: "After dinner", right: "brush teeth / do homework" },
            { left: "Before bed", right: "set alarm / feed pets" },
            { left: "Security", right: "lock doors / turn off stove" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 10: FAMILY CONVERSATIONS MASTERY (10 preguntas)
    // ===================================================================
    {
      id: "m6-u9-s10",
      title: "Set 10: Real Life Mastery",
      questions: [
        {
          type: "mc",
          q: "Parent: 'How was school?' Kid: 'It was fine.' Parent: '___'",
          options: ["Have you done your homework yet?", "Did you do your homework tomorrow?", "Are you doing homework?"],
          a: "Have you done your homework yet?",
          successtip: "✓PARENT SCRIPT!\nPredictable parent questions 😅\nSchool → Homework → Dinner\nEvery day 💯"
        },
        {
          type: "mc",
          q: "Roommate text: 'Can you buy milk?' Reply: '___'",
          options: ["I've already bought it!", "I already buy it!", "I bought it tomorrow!"],
          a: "I've already bought it!",
          tip: "ALREADY = anticipating the request",
          successtip: "✓PROACTIVE!\nAlready = good roommate 👍\nShows you're on it\nPrevents nagging"
        },
        {
          type: "order",
          q: "Context: Familiar situation. Traduce: ¿Dónde dejé mis llaves?",
          words: ["Where", "did", "I", "leave", "my", "keys?"],
          a: "Where did I leave my keys?",
          successtip: "✓UNIVERSAL QUESTION!\nEveryone loses keys 🔑\nDaily struggle mundial\nCheck your pocket 😂"
        },
        {
          type: "mc",
          q: "Boss: 'Did you send that email?' You: '___'",
          options: ["Yes, I've just sent it.", "Yes, I've sent it tomorrow.", "Yes, I'm sending it yesterday."],
          a: "Yes, I've just sent it.",
          tip: "JUST = very recently (good timing!)",
          successtip: "✓JUST SENT!\nJust = perfect timing ⏰\nShows efficiency\nWork conversation win 💼"
        },
        {
          type: "input",
          q: "Spouse: 'Have you ___ the bills?' (complete payment)",
          a: "paid",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓PAY BILLS!\nPay bills 💳\nAdult responsibility\nAutopay = modern solution 🤖"
        },
        {
          type: "order",
          q: "Context: Mensaje a friend. Traduce: ¿Recibiste mi mensaje?",
          words: ["Did", "you", "get", "my", "message?"],
          a: "Did you get my message?",
          successtip: "✓GET MESSAGE!\n'Get' = receive 📱\nFollowing up\n'Read receipts' = modern stress 👀"
        },
        {
          type: "mc",
          q: "Multiple reminders: Mom says 'Don't forget X' three times. Best response:",
          options: ["I know, I've already done it!", "I know, I do it!", "I know, I did it tomorrow!"],
          a: "I know, I've already done it!",
          successtip: "✓MOM NAGS!\n'I've already...' = stop the nagging 😅\nDefensive but polite\nUniversal teenager response"
        },
        {
          type: "mc",
          q: "Natural flow: 'Have you been to Japan?' 'Yes!' Next question:",
          options: ["When did you go? / How was it?", "When have you gone? / How has it been?", "When do you go? / How is it?"],
          a: "When did you go? / How was it?",
          tip: "Experience (Perfect) → Details (Simple)",
          successtip: "✓CONVERSATION FLOW!\nPerfect opens 🎯\nSimple details 📖\nNative pattern 100% 💯"
        },
        {
          type: "order",
          q: "Context: Saliendo de casa rush. Traduce: ¿Tienes todo?",
          words: ["Do", "you", "have", "everything?"],
          a: "Do you have everything?",
          successtip: "✓EVERYTHING!\n'Have everything?' = leaving house check ✅\nPhone, keys, wallet\nModern essentials"
        },
        {
          type: "mc",
          q: "FINAL MASTERY: Most natural daily conversation:",
          options: ["'Have you walked the dog yet?' 'Not yet, I'll do it now.'", "'Did you walk the dog yet?' 'Not already.'", "'Are you walking the dog yet?' 'Not just.'"],
          a: "'Have you walked the dog yet?' 'Not yet, I'll do it now.'",
          successtip: "✓UNIT 9 COMPLETE! 🎉🏆\n\nMAESTRÍA DIARIA ALCANZADA:\n✓ YET (todavía no) - pending\n✓ JUST (acabo de) - very recent\n✓ ALREADY (ya) - completed early\n✓ Present Perfect + Past Simple flow\n✓ 80+ DAILY LIFE VOCABULARY:\n  🌅 Morning: wake up, get up, shower, get dressed, brush teeth, make coffee\n  🏠 Chores: walk dog, feed cat, do laundry, make bed, take out trash\n  💬 Communication: text, reply, call back, check phone, send email\n  🔑 Lost items: keys, phone, remote, wallet, glasses, charger\n  🌙 Evening: set alarm, lock doors, pack lunch, turn off lights\n✓ Natural family conversations\n✓ Roommate dynamics\n✓ Parent-kid exchanges\n✓ Work communication\n✓ Real-world applicable!\n\nPuedes ahora:\n🗣️ Hablar de tu día a día\n✅ Checar responsabilidades\n❓ Preguntar por tareas\n📱 Comunicarte naturalmente\n🔍 Buscar cosas perdidas\n👨‍👩‍👧‍👦 Navegar conversaciones familiares\n💼 Manejar situaciones laborales\n🏠 Coordinarte con roommates\n🎯 Usar YET/JUST/ALREADY perfectamente\n\n¡NIVEL B1-B2 CONSOLIDADO!\n¡Esto es inglés PRÁCTICO y ÚTIL! 💪\n\nMódulo 6 casi completo! 🚀"
        }
      ]
    }
  ],

  // ===================================================================
  // READING SET - PROGRESSIVE FORMAT (10 preguntas)
  // ===================================================================
  readingSet: {
    id: "m6-u9-reading",
    title: "Reading Practice - Family Group Chat",
    category: "reading",
    
    questions: [
      // BLOQUE 1: Morning (7:30 AM)
      {
        type: "passage",
        passage: `**Family Group Chat - "The Johnsons"**

**Tuesday, 7:30 AM**

**Mom:**
Good morning everyone! Quick reminder:
- Jake, have you walked Max yet? He's whining at the door.
- Sarah, don't forget to take your lunch. I've already made it - it's in the fridge.
- Dad, the trash needs to go out before 8 AM.

Let's try to have dinner together tonight. I'll be home by 6.

**Jake:**
Morning! Not yet, Mom. I just woke up. I'll walk him in 10 minutes, I promise.

**Sarah:**
Thanks Mom! I've already packed my bag and I'm almost ready. Have you seen my headphones? I can't find them anywhere.

**Dad:**
I've just taken out the trash. Also, I fed Max already - he was starving!`
      },
      {
        type: "mc",
        q: "Jake says 'I just woke up' - why 'just'?",
        options: ["Shows he woke up very recently (moments ago)", "He woke up yesterday", "He will wake up soon"],
        a: "Shows he woke up very recently (moments ago)",
        tip: "JUST = very recent action",
        successtip: "✓JUST!\nJust = hace nada ⏰\nExplains why he hasn't walked dog yet"
      },
      {
        type: "mc",
        q: "Mom asks 'Have you walked Max YET?' What does YET show?",
        options: ["Checking if pending task is done", "Asking about yesterday", "Asking about next week"],
        a: "Checking if pending task is done",
        successtip: "✓YET CHECKING!\nYet = checking status ✅\nTypical parent question pattern"
      },

      // BLOQUE 2: Mid-Morning (10:00 AM)
      {
        type: "passage",
        passage: `**10:00 AM**

**Sarah:**
Found them! They were in my jacket pocket 🤦‍♀️

BTW, has anyone called Grandma yet? It's her birthday tomorrow and I haven't bought a present yet.

**Mom:**
I've already called her this morning and ordered flowers. But you should still call her, Sarah. She loves hearing from you.

**Jake:**
Update: I've walked Max and fed him again (even though Dad already did - oops, double breakfast for Max 😂). Now I'm getting ready for school.

Mom, where did you put my gym clothes? I washed them yesterday.

**Mom:**
I've already put them away. Check your drawer.`
      },
      {
        type: "mc",
        q: "Sarah says 'I haven't bought a present YET.' This means:",
        options: ["She still needs to buy it (pending)", "She bought it", "She won't buy it"],
        a: "She still needs to buy it (pending)",
        tip: "HAVEN'T...YET = still pending"
      },
      {
        type: "mc",
        q: "Mom uses 'I've ALREADY called her' to show:",
        options: ["She did it before being asked (proactive)", "She's calling right now", "She called last year"],
        a: "She did it before being asked (proactive)",
        successtip: "✓ALREADY!\nAlready = anticipating needs 👍\nGood mom energy"
      },

      // BLOQUE 3: Afternoon (3:00 PM)
      {
        type: "passage",
        passage: `**3:00 PM**

**Dad:**
Quick question - has anyone seen the TV remote? I've looked everywhere but can't find it.

**Sarah:**
Did you check between the couch cushions? That's where I found it yesterday.

**Jake:**
I've just got home from school. I'm starving! Did anyone leave food for me?

**Mom:**
There's pizza in the fridge. Jake, have you done your homework yet? Don't leave it until tonight like last time.

**Jake:**
Not yet, but I'll start after I eat. I promise!

**Dad:**
Found it! It was under the couch. Thanks Sarah!`
      },
      {
        type: "mc",
        q: "Why does Sarah use Past Simple 'Did you check...?' instead of Perfect?",
        options: ["Asking about a specific action/location", "Talking about life experience", "Describing current action"],
        a: "Asking about a specific action/location",
        tip: "Specific WHERE question = Past Simple",
        successtip: "✓WHERE = SIMPLE!\nWhere/when questions → Simple 📍\nAsking specific details"
      },
      {
        type: "mc",
        q: "Jake says 'Not yet, but I'll...' What does this show?",
        options: ["Haven't done it BUT will do it soon", "Did it already", "Won't do it"],
        a: "Haven't done it BUT will do it soon",
        successtip: "✓NOT YET!\n'Not yet' = todavía no ⏰\nBut promising to do it\nClassic kid response 😅"
      },

      // BLOQUE 4: Evening (6:30 PM)
      {
        type: "passage",
        passage: `**6:30 PM**

**Mom:**
I'm home! Is everyone ready for dinner? I've just finished cooking.

**Sarah:**
I've already set the table. Can I help with anything else?

**Dad:**
I've just changed clothes. Be there in 2 minutes. Jake, have you finished your homework yet?

**Jake:**
Almost! I've done the math and English. I just need to finish science. Can I do it after dinner?

**Mom:**
Fine, but right after dinner. And Jake, have you called Grandma yet?

**Jake:**
Oh no! I forgot! I'll call her right now before dinner.`
      },
      {
        type: "mc",
        q: "How many times is 'JUST' used to show very recent actions?",
        options: ["Three (finished cooking, changed clothes, need to finish)", "One", "None"],
        a: "Three (finished cooking, changed clothes, need to finish)",
        tip: "Count the 'just' uses"
      },
      {
        type: "mc",
        q: "Mom keeps asking 'Have you...yet?' because:",
        options: ["She's checking if responsibilities are completed", "She's angry", "She forgot she asked"],
        a: "She's checking if responsibilities are completed",
        successtip: "✓PARENT PATTERN!\n'Have you...yet?' = parent script 👩\nChecking todos ✅\nEveryday family dynamic"
      },

      // PREGUNTAS FINALES
      {
        type: "mc",
        q: "Throughout the chat, ALREADY is used to:",
        options: ["Show tasks completed before being asked", "Show future plans", "Show past habits"],
        a: "Show tasks completed before being asked",
        successtip: "✓ALREADY PATTERN!\nAlready = proactive ✓\nShows responsibility\nMakes people happy 😊"
      },
      {
        type: "mc",
        q: "This family chat shows:",
        options: ["Real daily life conversations with YET/JUST/ALREADY", "Formal business communication", "Travel planning"],
        a: "Real daily life conversations with YET/JUST/ALREADY",
        successtip: "✓READING COMPLETE! 🎉\n\nPATTERNS VISTOS:\n✓ YET = checking pending (Have you...yet?)\n✓ JUST = very recent (I've just done it)\n✓ ALREADY = completed early (I've already done it)\n✓ NOT YET = still pending\n✓ Where did you...? = Past Simple\n\nFAMILY DYNAMICS:\n👩 Mom = organizer/checker\n👨 Dad = helper\n👧 Sarah = responsible kid\n👦 Jake = typical teenager 😅\n\nDAILY VOCABULARY:\n🐕 Walk/feed dog\n🎒 Pack bag/lunch\n🗑️ Take out trash\n📚 Do homework\n📞 Call family\n🍕 Make/eat food\n📺 Find remote\n🔑 Lost items\n\nREAL LIFE:\nThis is EXACTLY how families text 💯\nThese patterns = daily English\nSuper practical!\n\n¡Ya puedes navegar conversaciones diarias! 🌟"
      }
    ]
  },

  // ===================================================================
  // REVIEW SET (10 preguntas)
  // ===================================================================
  reviewSet: {
    id: "m6-u9-review",
    title: "Unit Review - Daily Life Mastery",
    category: "review",
    exercises: [
      {
        type: "mc",
        q: "REVIEW: Task completed before being asked:",
        options: ["I've already done it.", "I've just done it.", "I haven't done it yet."],
        a: "I've already done it.",
        tip: "ALREADY = ya lo hice (proactive)"
      },
      {
        type: "mc",
        q: "REVIEW: Task still pending:",
        options: ["I haven't done it yet.", "I've already done it.", "I've just done it."],
        a: "I haven't done it yet.",
        tip: "YET = todavía no"
      },
      {
        type: "mc",
        q: "REVIEW: Action happened moments ago:",
        options: ["I've just finished.", "I've already finished.", "I haven't finished yet."],
        a: "I've just finished.",
        tip: "JUST = acabo de"
      },
      {
        type: "input",
        q: "REVIEW: Position - 'I have ___ done my homework.' (ya)",
        a: "already",
        accept: { ignoreCase: true, ignorePunctuation: true },
        tip: "ALREADY after HAVE"
      },
      {
        type: "mc",
        q: "REVIEW: Where does YET go? 'I haven't finished ___'",
        options: ["yet (at the end)", "yet (after haven't)", "yet (at beginning)"],
        a: "yet (at the end)",
        tip: "YET at end of sentence"
      },
      {
        type: "order",
        q: "REVIEW: Traduce - ¿Ya sacaste al perro?",
        words: ["Have", "you", "walked", "the", "dog", "yet?"],
        a: "Have you walked the dog yet?"
      },
      {
        type: "mc",
        q: "REVIEW: Asking about location (lost item):",
        options: ["Where did you put it?", "Where have you put it?", "Where are you putting it?"],
        a: "Where did you put it?",
        tip: "WHERE = Past Simple"
      },
      {
        type: "match",
        q: "REVIEW: Match time markers to meaning",
        pairs: [
          { left: "already", right: "ya (completed early)" },
          { left: "yet", right: "todavía no (pending)" },
          { left: "just", right: "acabo de (very recent)" }
        ],
        a: "completed"
      },
      {
        type: "mc",
        q: "REVIEW: Daily routine question:",
        options: ["Have you brushed your teeth yet?", "Did you brush your teeth already?", "Are you brushing your teeth yet?"],
        a: "Have you brushed your teeth yet?"
      },
      {
        type: "mc",
        q: "FINAL REVIEW: Natural daily conversation:",
        options: ["'Have you done the laundry yet?' 'Not yet, I'll do it now.'", "'Did you do the laundry yet?' 'Not already.'", "'Are you doing laundry yet?' 'Not just.'"],
        a: "'Have you done the laundry yet?' 'Not yet, I'll do it now.'",
        successtip: "✓UNIT 9 MASTERY! 🎉🏆\n\nCONQUISTAS:\n✓ YET - pending tasks\n✓ JUST - recent actions  \n✓ ALREADY - proactive completion\n✓ 80+ daily vocabulary\n✓ Morning/evening routines\n✓ Household responsibilities\n✓ Communication patterns\n✓ Lost items navigation\n✓ Family dynamics\n✓ Real-world conversations\n\n¡INGLÉS PRÁCTICO DOMINADO!\n¡Esto es 100% aplicable HOY! 💪\n\nMódulo 6 CASI COMPLETO! 🎊\nOne more unit to go! 🚀"
      }
    ]
  }
};
